import { Route, Routes } from 'react-router';

import { RequireAuth } from '@/components/RequireAuth';
import { CalendarPage } from '@/pages/CalendarPage';
import { CapturePage } from '@/pages/CapturePage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { HealthPage } from '@/pages/HealthPage';
import { HistoryPage } from '@/pages/HistoryPage';
import { LoginPage } from '@/pages/LoginPage';
import { RegisterPage } from '@/pages/RegisterPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { TimelapsePage } from '@/pages/TimelapsePage';

const signedIn = [
  { path: '/', element: <CapturePage /> },
  { path: '/history', element: <HistoryPage /> },
  { path: '/calendar', element: <CalendarPage /> },
  { path: '/timelapse', element: <TimelapsePage /> },
  { path: '/settings', element: <SettingsPage /> },
];

export function App() {
  return (
    <Routes>
      {signedIn.map(({ path, element }) => (
        <Route key={path} path={path} element={<RequireAuth>{element}</RequireAuth>} />
      ))}

      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      {/* Where the link in the reset email lands, token and email in the query. */}
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Kept reachable: the fastest way to tell a broken local environment
          apart from a broken feature. */}
      <Route path="/health" element={<HealthPage />} />
    </Routes>
  );
}
